module.exports = __webpack_public_path__ + "img/h-2.d24e1648.svg";